export interface NewPub {
    doi: string;
    name: string;
    summary: string;
    journal: string;
    type: string;
    authors: string;
    filteredAuthors: string;
    affiliations: string[];
    citations: number;
    status: string;
    publisher: string;
    date: Date | null;
    dateAdded: Date | null;
    scraped: boolean;
    fanout: {
        request: boolean;
        completed: boolean;
        verdict: boolean | null;
    };
    supplementary: {
        code?: Record<string, string[]>;
        data?: Record<string, string[]>;
        containers?: Record<string, string[]>;
        results?: Record<string, string[]>;
        trials?: Record<string, string[]>;
        protocols?: Record<string, string[]>;
        packages?: Record<string, string[]>;
        miscellaneous?: Record<string, string[]>;
    };
    otherLinks: {
        name: string;
        description: string;
        recommendedCategory: string;
        link: string;
    }[];
    submitter: string;
}

export function createDefaultNewPub(): NewPub {
    return {
        doi: '',
        name: '',
        summary: '',
        journal: '',
        type: '',
        authors: '',
        filteredAuthors: '',
        affiliations: [],
        citations: 0,
        status: 'Published',
        publisher: '',
        date: null,
        dateAdded: new Date(),
        scraped: false,
        fanout: {
            request: false,
            completed: false,
            verdict: null
        },
        supplementary: {
            code: {},
            data: {},
            containers: {},
            results: {},
            trials: {},
            protocols: {},
            packages: {},
            miscellaneous: {}
        },
        otherLinks: [],
        submitter: ''
    };
}
